<template>
  <el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="30%" :before-close="close">
    <div slot="title" class="title">{{disabled == false?'新建角色':'修改角色'}}</div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="角色名" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
		<el-form-item label="组长">
			<el-select
			  style="width: 100%"
			  v-model="ruleForm.group_leader"
			  placeholder="请选择组长"
			>
			  <el-option :label="v.name" :value="v.id" v-for="(v,k) in users" :key="k"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="备注" prop="remark">
		  <el-input v-model="ruleForm.remark"></el-input>
		</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="small-btn btn-bor" size="small" @click="close"
        >取 消</el-button
      >
      <el-button
        class="small-btn bgC"
        size="small"
        type="primary"
        @click="submitForm('ruleForm')"
        >{{disabled == false?'确 定':'修 改'}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
	  disabled: {
	    type: Boolean,
	    default() {
	      return false;
	    },
	  },
	
	accountObj:{
		type:Object,
		default(){
			return {}
		}
	},
	users:{
		type:Array,
		default(){
			return []
		}
	},
  },
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        title: "",
		remark:"",
		group_leader:''
      },
      rules: {
	    // group_leader: [{ required: true, message: "请输入组长", trigger: "blur" }],
        title: [{ required: true, message: "请输入角色名", trigger: "blur" }],
		remark:[{ required: true, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  methods: {
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			if(this.disabled){
				this.$emit('editRole',this.ruleForm)
			}else{
				this.$emit('addRole',this.ruleForm)
			}
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
    //   关闭弹框
    close() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.title {
  text-align: left;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 10px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>